"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import posthog from "posthog-js";
import { useEffect, useState } from "react";
import { HotkeysProvider, useHotkeys } from "react-hotkeys-hook";
import AccentButton from "~/designSystem/components/Buttons/AccentButton";

import { POSTHOG_EVENTS } from "~/core/constants/analytics";
import { routes } from "~/core/constants/routes";

import { SessionUser } from "~/lib/auth/types";
import useCurrentUser from "~/lib/organizations/hooks/use-current-user";

const PrimaryCTA = (props: React.PropsWithChildren) => {
  const currentUser = useCurrentUser(); // Get the user directly
  const [currentUserState, setCurrentUserState] = useState<SessionUser | null>(
    currentUser,
  );

  useEffect(() => {
    setCurrentUserState(currentUser); // Update state when currentUser changes
  }, [currentUser]);

  const router = useRouter();

  useHotkeys(
    "d",
    () => {
      if (!!currentUserState) {
        router.push("/dashboard");
      }
    },
    [],
  );

  return (
    <div className="max-w-xs mx-auto space-y-4 flex justify-center">
      {!!currentUserState ? (
        <Link href={routes.appDefaultLanding}>
          <AccentButton
            icon12pxRight="ArrowRight_12_Outline"
            label="Dashboard"
          />
        </Link>
      ) : (
        <Link
          href={routes.auth.signIn}
          onClick={() => {
            posthog.capture(POSTHOG_EVENTS.HOMEPAGE.GET_STARTED_CLICKED);
          }}
        >
          <AccentButton
            icon12pxRight="ArrowRight_12_Outline"
            label="Get Started"
          />
        </Link>
      )}
    </div>
  );
};

export const PrimaryCTASessionProvider = (props: React.PropsWithChildren) => {
  return (
    <HotkeysProvider>
      <PrimaryCTA />
      <div className="flex items-center gap-1.5 text-sm text-gray-500 pt-2">
        <p>Hear directly from founders. No spam. Just real updates.</p>
      </div>
    </HotkeysProvider>
  );
};
